export default "__VITE_ASSET__6d5bcb92__"